module.exports = __webpack_public_path__ + "img/bg_chess_08.64488d58.jpg";